export const boardDocumentationTour = {
  key: "boardDocumentation",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-documentation-search"]',
      content: t("Tour_BoardDocumentation_Search"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-documentation-add"]',
      content: t("Tour_BoardDocumentation_Add"),
      placement: "top",
    },
    {
      target: '[data-tour="board-documentation-edit"]',
      content: t("Tour_BoardDocumentation_Edit"),
      placement: "top",
    },
  ],
};
